import { makeStyles } from 'tss-react/mui';

const useStylesControlModeBlock: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  controlModeBlock: {
    whiteSpace: 'nowrap',
    marginLeft: 'auto',
  },
  controlModeBlockMultiline: {
    [theme.breakpoints.down('md')]: {
      marginTop: 5,
      marginRight: 'auto',
      marginLeft: 0,
    },
  },
  controlModeBlockHidden: {
    display: 'none',
  },
}));

export default useStylesControlModeBlock;
